const windowEnvironment = window.__solEnv;

/**
 * Attempts to read values from the `windowEnvironment` and will
 * use `process.env` as a fallback. This allows for runtime configuration
 * to supersede built in values.
 *
 * @param key environment variable or tag name
 */
const getConfigValue = (key: string) => {
  const environmentDef = process.env && process.env[`${key}`];
  const runtimeDef = windowEnvironment && windowEnvironment[`${key}`];

  // take window environment over process since this is injected at runtime
  const preferredDefinition = runtimeDef || environmentDef;

  return preferredDefinition;
};

export default { getConfigValue };
